"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProgrammableConfig = exports.programmableConfig = exports.getProgrammableConfigSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getProgrammableConfigSerializer() {
    return (0, serializers_1.dataEnum)([
        [
            'V1',
            (0, serializers_1.struct)([
                ['ruleSet', (0, serializers_1.option)((0, serializers_1.publicKey)())],
            ]),
        ],
    ], { description: 'ProgrammableConfig' });
}
exports.getProgrammableConfigSerializer = getProgrammableConfigSerializer;
function programmableConfig(kind, data) {
    return Array.isArray(data)
        ? { __kind: kind, fields: data }
        : { __kind: kind, ...(data ?? {}) };
}
exports.programmableConfig = programmableConfig;
function isProgrammableConfig(kind, value) {
    return value.__kind === kind;
}
exports.isProgrammableConfig = isProgrammableConfig;
//# sourceMappingURL=programmableConfig.js.map